export function getPagesAmount(itemsAmount) {
    const windowWidth = window.innerWidth;
    let linesAmount = 12;
    let itemsPerLine = 1;
    if (windowWidth >= 728) {
        itemsPerLine = 2;
        linesAmount = 6;
    }
    if (windowWidth >= 1123) {
        itemsPerLine = 4;
        linesAmount = 3;
    }
    const itemsAmountPerPage = itemsPerLine * linesAmount;
    return {
        linesAmount,
        itemsPerLine,
        pagesAmount: Math.ceil(itemsAmount / itemsAmountPerPage),
        itemsAmountPerPage,
    };
}
